import { render, staticRenderFns } from "./CardSpotlightRestaurant.vue?vue&type=template&id=03730b52&scoped=true&"
import script from "./CardSpotlightRestaurant.vue?vue&type=script&lang=js&"
export * from "./CardSpotlightRestaurant.vue?vue&type=script&lang=js&"
import style0 from "./CardSpotlightRestaurant.vue?vue&type=style&index=0&id=03730b52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03730b52",
  null
  
)

export default component.exports